import { SET_PARAMS, RESET } from "../types";

export default function (state = [], action) {
    switch (action.type) {
        case SET_PARAMS:
            return {
                pageId: action.pageId,
                questionId: action.questionId,
                blockDisplayLogic: action.blockDisplayLogic,
                questionDisplayLogic: action.questionDisplayLogic,
                questionRequiredLogic: action.questionRequiredLogic,
            };

        case RESET:
            return [];

        default:
            return state;
    }
}
